import { useCallback, useEffect, useRef, useState } from "react";
import { Box, Button, chakra, Flex } from "@chakra-ui/react";
import { useControls } from "src/utils/createControls";

import { useSelector } from "react-redux";
import * as selectors from "src/modules/command/duck/selectors";
import OldFlow from "src/components/Flow";
import PopoverView from "src/components/PopoverView";
import NoCommands from "src/modules/command/scenes/NoCommands";
import CommandsList from "src/modules/command/scenes/CommandsList";
import CommandEditor from "src/modules/command/scenes/Editor/CommandEditor";

import Flow from "./CustomFlowStory";

const steps = [
  {
    id: "commands",
    Component: ({ commands, flow, onClose, onBack, initialStep }) => {
      let commandsArray = Object.values(commands);

      return commandsArray.length === 0 ? (
        <NoCommands
          onClose={onClose}
          onBack={onBack}
          openEditor={() => flow.push("editor")}
        />
      ) : (
        <CommandsList
          commands={commands}
          onClose={onClose}
          onBack={onBack}
          openEditor={(commandId) =>
            flow.push("editor", { state: { commandId } })
          }
        />
      );
    }
  },
  {
    id: "editor",
    Component: ({ onClose, onBack, flow, initialStep, commands }) => {
      return (
        <CommandEditor
          onClose={onClose}
          onBack={initialStep === "editor" ? onBack : flow.previous}
          command={flow.state && commands[flow.state.commandId]}
          afterSave={() => flow.push("commands")}
        />
      );
    }
  }
];

function OldCommandsFlow({ initialStep, ...rest }) {
  const commands = useSelector(selectors.getCommands);

  return (
    <OldFlow
      commands={commands}
      initialStep={initialStep}
      steps={steps}
      {...rest}
    />
  );
}

function CommandsFlow({ initialStep, ...rest }) {
  const commands = useSelector(selectors.getCommands);
  return (
    <Flow
      commands={commands}
      steps={steps}
      initialStep={initialStep}
      {...rest}
    />
  );
}

export default function RecreateFlow() {
  const flow = useControls();
  const oldFlow = useControls();

  return (
    <Box bg="surfaceElevated1" w="100vw" h="100vh">
      <Button onClick={oldFlow.open} mr="2rem">
        Open old flow
      </Button>
      <Button onClick={flow.open}>Open new flow</Button>
      <PopoverView
        isOpen={oldFlow.isOpen}
        onClose={oldFlow.close}
        modalProps={{ closeOnOverlayClick: false }}
      >
        <OldCommandsFlow onClose={oldFlow.close} initialStep="commands" />
      </PopoverView>

      <PopoverView
        isOpen={flow.isOpen}
        onClose={flow.close}
        modalProps={{ closeOnOverlayClick: false }}
      >
        <CommandsFlow onClose={flow.close} initialStep="commands" />
      </PopoverView>
    </Box>
  );
}
